import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {SiteAppComponent} from "./site-app.component";
import {SiteAppRoutingModule} from "./site-app-routing.module";
import {HomeComponent} from "../+home/home.component";
import {NewsComponent} from "../+news/news.component";
import {CatalogsComponent} from "../+catalogs/catalogs.component";
import {ContactsComponent} from "../+contacts/contacts.component";
import {ProductsComponent} from "../+products/products.component";
import {VideoComponent} from "../+video/video.component";
import {NewsService} from "../shared/news.service";
import {MapComponent} from "../shared/map/map.component";
import {PartnersComponent} from "../+partners/partners.component";

@NgModule({
  imports: [
    SharedModule,
    SiteAppRoutingModule
  ],
  declarations: [
    SiteAppComponent,
    HomeComponent,
    NewsComponent,
    CatalogsComponent,
    ContactsComponent,
    ProductsComponent,
    VideoComponent,
    MapComponent,
    PartnersComponent
  ],
  providers: [
    NewsService
  ]
})
export class SiteAppModule {

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+site-app/site-app.module.ts